'use client';

import { usePathname } from 'next/navigation';
import { useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FloatingRotateButton from '@/components/button/FloatingRotateButton';

export default function ClientRoot({ children }) {
    const pathname = usePathname();
    const footerRef = useRef(null);

    const isExperienceHome = pathname === '/experience';
    const hideDetailFloating =
        pathname.startsWith('/recruit') ||
        pathname.startsWith('/request') ||
        pathname.startsWith('/contact');

    const hidePlusFloating =
        pathname.startsWith('/recruit') ||
        pathname.startsWith('/request') ||
        pathname.startsWith('/subscribe');

    return (
        <>
            <Header className={isExperienceHome ? 'bg_black' : ''} />

            <div className="floating_wrapper">
                <section>{children}</section>
                {!hidePlusFloating && (
                    <FloatingRotateButton
                        href="/request"
                        imgSrc="/img/text_request_w.svg"
                        hoverImgSrc="/img/text_request_hover.svg"
                        imgAlt="프로젝트 문의하기 버튼"
                        footerObs={footerRef}
                        hideDetailFloating={hideDetailFloating}
                    />
                )}
            </div>
            {pathname === '/' ? null : <Footer ref={footerRef} />}
        </>
    );
}
